import { render, staticRenderFns } from "./YourResponsibilitiesTable.vue?vue&type=template&id=701f903c"
import script from "./YourResponsibilitiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./YourResponsibilitiesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourResponsibilitiesTable.vue?vue&type=style&index=0&id=701f903c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports